module.exports = __webpack_public_path__ + "img/5b3e021.png";